class App {
    constructor() {
        new IE11Polyfill();
        new DataTablesController().initDataTablesController();

        new filterFunctions();

        //new OOFilter();
        new HelpModal();
    }
}

new App();
